import feedbackService from './feedbackService'

export default feedbackService



// WEBPACK FOOTER //
// ../src/services/feedbackService/index.js